export default {
  title: {
    confirmUpdateSelfResumeTitle: '是否更新自身简历？'
  },
  tabTitle: {
    index: '我的档案',
    resumeAdd: '添加简历',
    resumeEdit: '编辑简历',
    submitResume: '提交简历',
    applySuccess: '申请完成',
    editSuccess: '完成',
    importResume: '导入简历'
  },
  homeMenu: {
    name: '我的简历',
    desc: '创建或者修改简历'
  },
  label: {
    age: '岁',
    submitTitle: '提交/上传简历',
    uploadResume: '上传简历',
    emailAddress: '邮箱',
    phoneNumber: '手机号码',
    currentCompany: '当前公司',
    currentPosition: '当前职位',
    referralReason: '推荐原因',
    upload: '上传',
    referralSuccess: '您已完成候选人的简历上传。请您提醒候选人查阅系统发送的邮件，完成个人信息授权。届时您的推荐将完成。感谢您的支持！',
    uploadSuccess: '上传成功',
    applySuccess: '申请完成',
    successDescription: '感谢您申请{company}的{title}一职。您的申请已经被成功提交。',
    invitationUrl: '再次感谢您的申请，我们想知道您的体验以及我们可以如何做的更好。请花90秒钟的时间分享一下您的反馈。点击<a href="{invitationUrl}" target="_blank" >这里</a>开始分享吧！',
    alreadyApplied: '您已申请过该职位',
    appliedDescription: '您已成功申请该职位，请勿重复提交。您可在申请记录中查看申请状态。',
    thankApply: '感谢您的申请',
    assessmentDescription: '您的简历已经被成功提交。祝您好运！',
    assessmentDescriptionTip: '为了提高您的简历成功率，我们建议您完成性格测评（大约需要花10-15分钟的时间）。完成之后，您将会收到相应的个人发展报告！',
    doAssessment: '点击这里完成性格测评',
    moreInfo: '更多信息：',
    seeAllJobs: '查看所有职位',
    coachAI: '请使用微信扫描二维码参加AI面试',
    followUs: '扫一扫关注我们微信吧！',
    congratulations: '恭喜！',
    editResumeSuccess: '您已经完成了简历。',
    personal: '我的信息',
    refereeInfo: '被推荐人信息',
    firstName: '名',
    lastName: '姓',
    applying: '申请处理中，请勿离开。',
    onRunningEightfoldTip: '请使用相同的电子邮箱在EF PCS注册，以便跟踪您的申请。'
  },
  btn: {
    seeDashboard: '查看更多职位',
    moreReferral: '推荐另一位候选人',
    toPersonalHome: '查看个人中心',
    viewReport: '查看报告',
    homePage: '我的个人主页',
    jobList: '返回职位列表',
    continueApply: '继续申请'
  },
  placeholder: {
    input: '请输入',
    select: '请选择',
    startDate: '开始日期',
    endDate: '结束日期',
    currencyUnit: '货币'
  },
  tips: {
    uploadResume: '点击或将文件拖放到这里',
    submitTips: '请上传您的推荐简历并提交。',
    referralSuccessTips: '感谢您的推荐',
    resumeTypeTips: '支持以下格式：pdf, doc, docx, shtml, html, png, jpg, jpeg 和 bmp',
    submitFailed: '您上传的候选人可能是重复候选人，请尽快联系对应的招聘专员。',
    uploadSuccessTips: '您已成功上传简历',
    candidateSubmitPolicy: '本人确认已获得候选人授权同意提交此推荐简历。',
    agencySubmitPolicy: '作为候选人委托的猎头顾问，本人确认已获得候选人授权同意推荐该简历，并将遵守保密协议及行业操守。'
  },
  message: {
    requireEnter: '请输入',
    requireSelect: '请选择',
    hasUploadedInTalentPool: '该候选人已存在于公司人才库中，请勿重复上传！'
  }
}
